import { Expose, Type } from 'class-transformer';
import { Feature, Point } from 'geojson';
import { Observable, Subject } from 'rxjs';

import { SnUser, SnTeam } from '@lib/api/entities';
import { ExposeRawData } from '@lib/common/decorators';

import { SnLiveIncident } from './live-incident.model';

export class SnLiveUser extends SnUser {
  @Expose()
  @Type(() => SnLiveIncident)
  public liveIncident: SnLiveIncident;

  @Expose()
  @ExposeRawData()
  public geometry: Point;

  private _isSelected = false;
  private readonly _liveStatusChanged$ = new Subject<boolean>();

  constructor(data: any = {}) {
    super(data);
  }

  get liveStatusChanged$(): Observable<boolean> {
    return this._liveStatusChanged$.asObservable();
  }

  get isSelected(): boolean {
    return this._isSelected;
  }

  get coords(): { lng: number; lat: number } {
    return {
      lng: this.geometry.coordinates[0],
      lat: this.geometry.coordinates[1],
    };
  }

  public changeCallSign(callSign: string, team: SnTeam): void {
    this.callSign = callSign;
    this.team = team;
  }

  public move(geometry: Point, speed: number, altitude: number): void {
    this.geometry = geometry;
    this.speed = speed;
    this.altitude = altitude;
    this.updatedAt = new Date();
  }

  public select(): void {
    this._isSelected = true;
  }

  public deselect(): void {
    this._isSelected = false;
  }

  public remove(): void {
    this.mobileLoggedIn = false;
    this.updatedAt = new Date();

    this._liveStatusChanged$.complete();
  }

  public startIncident(incident: SnLiveIncident): void {
    this.isLive = true;
    this.liveIncident = incident;
    this._liveStatusChanged$.next(true);
  }

  public stopIncident(): void {
    this.isLive = false;
    this.liveIncident = undefined;
    this._liveStatusChanged$.next(false);
  }

  public toGeoJSON(): Feature<Point> {
    return {
      type: 'Feature',
      geometry: this.geometry,
      id: this.id,
      properties: {
        id: this.id,
        fullName: this.fullName,
        teamName: this.team.name,
        teamColor: this.team.color,
      },
    };
  }
}
